import css_5wqh46lfwn7 from './css/LayoutGrid.css';
import Div from './Div.js';
import TitleBarContainer from './TitleBarContainer.js';
import OverlayContainer from './OverlayContainer.js';
import PlaylistContainer from './PlaylistContainer.js';
import MediaGroupContainer from './MediaGroupContainer.js';

const css = css_5wqh46lfwn7;

export default class LayoutGrid extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.titleBarContainer = new TitleBarContainer(this);
		this.overlayContainer = new OverlayContainer(this);
		this.playlistContainer = new PlaylistContainer(this);
		this.mediaGroupContainer = new MediaGroupContainer(this);

		new ResizeObserver
		(
			() =>
			{
				const width = this.mediaGroupContainer.element.clientHeight*16/9+'px';
				this.setCssPropertyValue('barkerVideoWidth', width);
				this.mediaGroupContainer.activeMediaGroup.adPlayer.resize();
				this.mediaGroupContainer.preloadMediaGroup.adPlayer.resize();
			}
		)
		.observe(this.mediaGroupContainer.element);
	}

	get cssText()
	{
		return css;
	}
}